import { useToolkitPicker } from "../hooks/use-toolkit-picker";
import { ToolkitSelectionSummary } from "./toolkit-selection-summary";

export function FooterSummary() {
  const {
    state: {
      selectionMode,
      selectedToolkits,
      selectedTools,
      filteredToolkits,
      filteredTools,
      activeTab,
    },
    clearSelections,
    selectAll,
  } = useToolkitPicker();

  const allVisibleSelected =
    filteredToolkits.size === selectedToolkits.size &&
    filteredTools.size === selectedTools.size;

  const handleSelectAll = () => {
    const visibleFqns =
      activeTab === "toolkits"
        ? Array.from(filteredToolkits).flatMap((tk) =>
            tk.tools.map((t) => t.fully_qualified_name)
          )
        : Array.from(filteredTools).map((t) => t.fully_qualified_name);
    selectAll(visibleFqns);
  };
  if (selectionMode !== "multi") {
    return null;
  }

  return (
    <div className="w-full sm:w-auto">
      <ToolkitSelectionSummary
        allVisibleSelected={allVisibleSelected}
        onClear={clearSelections}
        onSelectAll={handleSelectAll}
        selectedToolkits={selectedToolkits}
        selectedTools={new Set(selectedTools.keys())}
        selectionMode={selectionMode}
      />
    </div>
  );
}
